/**
 * Customers MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import {
  CUSTOMER_STATS_QUERY_KEY,
  CUSTOMERS_LIST_QUERY_KEY,
  CUSTOMER_TOPINS_STATS_QUERY_KEY,
  CUSTOMER_TOPINS_REFERRALS_QUERY_KEY,
  LEADS_STATS_QUERY_KEY,
  buildCustomersListParams,
  buildLeadsStatsParams,
  fetchCustomerStatsFromApi,
  fetchCustomersListFromApi,
  fetchCustomerTopinsStatsFromApi,
  fetchCustomerReferralsFromApi,
  fetchLeadsStatsFromApi,
} from "./customersQueryApi";

export const customersQueryClient = makeMv2QueryClient();
setupMv2CachePersist(customersQueryClient, "customers");

const DEFAULT_LIST_PARAMS = buildCustomersListParams({
  pageSize: 30,
  page: 1,
  filterType: "all",
  search: "",
});

const DEFAULT_LEADS_STATS_PARAMS = buildLeadsStatsParams({
  eventKey: "",
  activityWindow: "all",
  activityDate: "",
});

/** Warm stats + first page of existing customers + TOPINS stats/referrals. */
export function prefetchCustomers() {
  return Promise.all([
    customersQueryClient.prefetchQuery({
      queryKey: [CUSTOMER_STATS_QUERY_KEY],
      queryFn: ({ signal }) => fetchCustomerStatsFromApi(signal),
    }),
    customersQueryClient.prefetchQuery({
      queryKey: [CUSTOMERS_LIST_QUERY_KEY, DEFAULT_LIST_PARAMS],
      queryFn: ({ signal }) => fetchCustomersListFromApi(DEFAULT_LIST_PARAMS, signal),
    }),
    customersQueryClient.prefetchQuery({
      queryKey: [CUSTOMER_TOPINS_STATS_QUERY_KEY],
      queryFn: ({ signal }) => fetchCustomerTopinsStatsFromApi(signal),
    }),
    customersQueryClient.prefetchQuery({
      queryKey: [CUSTOMER_TOPINS_REFERRALS_QUERY_KEY],
      queryFn: ({ signal }) => fetchCustomerReferralsFromApi(signal),
    }),
    customersQueryClient.prefetchQuery({
      queryKey: [LEADS_STATS_QUERY_KEY, DEFAULT_LEADS_STATS_PARAMS],
      queryFn: ({ signal }) => fetchLeadsStatsFromApi(DEFAULT_LEADS_STATS_PARAMS, signal),
    }),
  ]);
}
